import { AttendanceRegistrationTypeDto, AttendanceStateDto } from '../../api-service/clients';

const noRegistrationsLabel = 'Ingen registreringer';

function isEndRegistration(registrationType: AttendanceRegistrationTypeDto) {
  return registrationType === AttendanceRegistrationTypeDto.End;
}

export function getAttendanceStateDisplayName(attendanceState?: AttendanceStateDto, registrationType: AttendanceRegistrationTypeDto = AttendanceRegistrationTypeDto.Start) {
  switch (attendanceState) {
    case AttendanceStateDto.OnTime:
      return isEndRegistration(registrationType) ? 'Gik til tiden' : 'Til tiden';
    case AttendanceStateDto.NotOnTime:
      return isEndRegistration(registrationType) ? 'Gik før tid' : 'Ikke til tiden';
    case AttendanceStateDto.NotShown:
      return 'Udeblevet';
    case AttendanceStateDto.AbsenceWithReason:
      return 'Lovligt udeblevet';
    case AttendanceStateDto.NotRelevant:
      return 'Ikke relevant';
    default:
      return noRegistrationsLabel;
  }
}

export function getAttendanceStateDialogSentence(attendanceState: AttendanceStateDto, registrationType: AttendanceRegistrationTypeDto) {
  switch (attendanceState) {
    case AttendanceStateDto.OnTime:
      return isEndRegistration(registrationType) ? 'Borger gik til tiden' : 'Borger kom til tiden';
    case AttendanceStateDto.NotOnTime:
      return isEndRegistration(registrationType) ? 'Borger gik før tid' : 'Borger kom ikke til tiden';
    case AttendanceStateDto.NotShown:
      return isEndRegistration(registrationType) ? 'Borger er udeblevet fra lektionens afslutning' : 'Borger er udeblevet fra lektionens start';
    case AttendanceStateDto.AbsenceWithReason:
      return isEndRegistration(registrationType) ? 'Borger er lovligt udeblevet fra lektionens afslutning' : 'Borger er lovligt udeblevet fra lektionens start';
    case AttendanceStateDto.NotRelevant:
      return 'Registrering er ikke relevant for denne borger';
    default:
      return '';
  }
}

export function getCommentFieldLabel(attendanceState: AttendanceStateDto, registrationType: AttendanceRegistrationTypeDto) {
  const registrationIsTimed = attendanceState === AttendanceStateDto.OnTime || attendanceState === AttendanceStateDto.NotOnTime;
  if (!registrationIsTimed) {
    return 'Kommentar';
  }
  return isEndRegistration(registrationType) ? 'Kommentar vedrørende afgangstidspunkt' : 'Kommentar vedrørende ankomsttidspunkt';
}

export function getRegistrationTimeFieldLabel(registrationType: AttendanceRegistrationTypeDto) {
  return isEndRegistration(registrationType) ? 'Borger gik klokken' : 'Borger mødte ind klokken';
}
